import React from 'react';
import { useNestedNavigation } from '../../../utils/appNavigationNames';
import { AnimateLoadedContent, Loader } from '../../v2BaseComponents/Loader';
import { useFocusEffect, useRoute } from '@react-navigation/native';
import { captureFastenRedirectParams } from '../Tabs/Account/RedirectScreen';
import { Platform } from 'react-native';

export type RedirectScreenOwnProps = {};

export type RedirectScreenProps = RedirectScreenOwnProps;

const RedirectScreen: React.FC<RedirectScreenProps> = (_props) => {
    const { nestedAccountNavigation } = useNestedNavigation();
    const route = useRoute();

    // On mobile, deep link params (org_connection_id, etc.) arrive as route params.
    // Capture them before navigating to Account/RedirectScreen.
    if (Platform.OS !== 'web' && route.params) {
        captureFastenRedirectParams(route.params as Record<string, string>);
    }

    useFocusEffect(() => {
        nestedAccountNavigation('redirect', undefined);
    });

    return <AnimateLoadedContent isLoading={true}>{() => <Loader />}</AnimateLoadedContent>;
};

export default React.memo(RedirectScreen);
